import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'
import { colorsNew } from 'root/src/client/web/commonStyles'
import orEmpty from 'root/src/shared/util/orEmpty'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'

const style = {
	root: {
		position: 'relative',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'&:hover > div': {
			visibility: 'visible',
			opacity: 1,
		},
	},
	tooltip: {
		visibility: 'hidden',
		backgroundColor: colorsNew.dark2,
		position: 'absolute',
		minWidth: 200,
		top: 20,
		borderRadius: 6,
		display: 'flex',
		flexDirection: 'column',
		textAlign: 'center',
		boxShadow: '5px 5px 10px black',
		zIndex: 999,
		margin: 10,
		padding: [[10, 5]],
	},
	visible: {
		visibility: 'visible',
		opacity: 1,
	},
}

const TooltipWrapper = ({
	children, tooltipText, tooltipHeader, classes, visible, displayInTable,
}) => (
	<div className={classes.root} style={{ justifyContent: displayInTable ? 'flex-start' : 'center' }}>
		{tooltipText && (
			<div
				style={orEmpty(displayInTable, { left: 0 })}
				className={classNames(classes.tooltip, 'tooltipText', visible && classes.visible)}
			>
				{tooltipHeader && (
					<Typography
						variant={typographyVariants.miniBold}
						color={colorsNew.light4}
					>
						{tooltipHeader}
					</Typography>
				)}
				<Typography variant={typographyVariants.paragraphBold}>
					{tooltipText}
				</Typography>
			</div>
		)}
		{children}
	</div>
)

export default withStyles(style, { name: 'MuiTooltipWrapper' })(TooltipWrapper)
